/* Essential Materials — global.js */
(function () {
  "use strict";

  // Keep the header cart count in sync after add-to-cart via fetch (progressive enhancement).
  document.addEventListener("DOMContentLoaded", function () {
    var counts = document.querySelectorAll("[data-cart-count]");
    if (!counts.length) return;

    function refresh() {
      fetch("/cart.js", { headers: { "Accept": "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          counts.forEach(function (el) { el.textContent = cart.item_count; });
        })
        .catch(function () {});
    }

    // Refresh when returning to the tab (e.g. after checkout back-nav)
    document.addEventListener("visibilitychange", function () {
      if (!document.hidden) refresh();
    });
  });
})();
